import React from "react";
import CertificateFooter from "./CertificateFooter";

const formatSlashDate = (value) => {
  if (!value) return "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const [y, m, d] = value.split("-");
  return `${d}-${m}-${y}`;
};

/**
 * A4 preview for Wastewater / Liquid Effluent Quality Test Report.
 * Shared header / sign-off / disclaimer / footer.
 */
const WastewaterEffluentDocument = ({ doc }) => {
  if (!doc) return null;
  const assetsBase = doc.assetsBase || "";
  const logos = doc.footerLogos || [];
  const rows = Array.isArray(doc.test_result_rows) ? doc.test_result_rows : [];

  return (
    <div className="cc-pdf-page cc-ww-page">
      <div className="cc-pdf-header">
        <img className="cc-pdf-logo" src={`${assetsBase}/logo.jpg`} alt="TUV PAK" />
        <div className="cc-pdf-header-text">
          <strong>TUV PAK INSPEC</strong>
          <span>TECHANICAL UNIQUE VISION PAKISTAN INSPECTION &amp; CERTIFICATION</span>
        </div>
      </div>
      <img className="cc-pdf-rule" src={`${assetsBase}/header-bar.png`} alt="" />

      <h4 className="cc-ww-title">
        {doc.report_title || "WASTEWATER / LIQUID EFFLUENT QUALITY TEST REPORT"}
      </h4>

      <table className="cc-ww-meta">
        <tbody>
          <tr>
            <th>Company Name</th>
            <td>{doc.company_name}</td>
            <th>Report No.</th>
            <td>{doc.report_no}</td>
          </tr>
          <tr>
            <th>Project</th>
            <td>{doc.project}</td>
            <th>Date of Sampling</th>
            <td>{formatSlashDate(doc.date_of_sampling)}</td>
          </tr>
          <tr>
            <th>Client</th>
            <td>{doc.client}</td>
            <th>Date of Testing</th>
            <td>{formatSlashDate(doc.date_of_testing)}</td>
          </tr>
          <tr>
            <th>Location</th>
            <td>{doc.location}</td>
            <th>Report Date</th>
            <td>{formatSlashDate(doc.report_date || doc.issue_date)}</td>
          </tr>
        </tbody>
      </table>

      <div className="cc-ww-band">SAMPLE INFORMATION</div>
      <table className="cc-ww-sample">
        <tbody>
          <tr>
            <th>Sample ID</th>
            <td>{doc.sample_id}</td>
            <th>Sample Type</th>
            <td>{doc.sample_type}</td>
          </tr>
          <tr>
            <th>Sampling Location</th>
            <td>{doc.sampling_location}</td>
            <th>Sampling Method</th>
            <td>{doc.sampling_method}</td>
          </tr>
          <tr>
            <th>Sample Condition</th>
            <td>{doc.sample_condition}</td>
            <th>Date &amp; Time of Sampling</th>
            <td>{doc.sampling_datetime}</td>
          </tr>
        </tbody>
      </table>

      <div className="cc-ww-band">TEST RESULTS</div>
      <table className="cc-ww-results">
        <thead>
          <tr>
            <th>No.</th>
            <th>Parameter</th>
            <th>Test Method / Standard</th>
            <th>Unit</th>
            <th>Result</th>
            <th>Applicable Limit / Standard</th>
            <th>Compliance</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{row.parameter}</td>
              <td>{row.test_method}</td>
              <td>{row.unit}</td>
              <td>{row.result}</td>
              <td>{row.applicable_limit}</td>
              <td>{row.compliance}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="cc-ww-compliance">
        <b>Compliance Statement:</b> {doc.compliance_statement}
      </p>

      <table className="cc-pdf-sign">
        <thead>
          <tr>
            <th>Inspected By</th>
            <th>Approved By</th>
            <th>Company Seal</th>
            <th>QR Code</th>
          </tr>
        </thead>
        <tbody>
          <tr className="cc-pdf-sign-names">
            <td>{doc.inspected_by_name}</td>
            <td>{doc.approved_by_name}</td>
            <td rowSpan={2} className="cc-pdf-sign-seal">
              {doc.sealUrl && <img src={doc.sealUrl} alt="Company seal" />}
            </td>
            <td rowSpan={2} className="cc-pdf-sign-qr">
              {doc.qrDataUrl && <img src={doc.qrDataUrl} alt="QR code" />}
            </td>
          </tr>
          <tr className="cc-pdf-sign-images">
            <td>{doc.inspectedSignatureUrl && <img src={doc.inspectedSignatureUrl} alt="Inspector signature" />}</td>
            <td>{doc.approvedSignatureUrl && <img src={doc.approvedSignatureUrl} alt="Approver signature" />}</td>
          </tr>
        </tbody>
      </table>

      <div className="cc-pdf-disclaimer">
        <p>{doc.disclaimer_text}</p>
        <b>{doc.end_of_report_text}</b>
      </div>

      <CertificateFooter
        assetsBase={assetsBase}
        logos={logos}
        website={doc.footer_website}
        email={doc.footer_email}
        gmail={doc.footer_gmail}
      />
    </div>
  );
};

export default WastewaterEffluentDocument;
